/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'marker': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g><path d="M10.0002 10.8327C11.3809 10.8327 12.5002 9.71339 12.5002 8.33268C12.5002 6.95197 11.3809 5.83268 10.0002 5.83268C8.61945 5.83268 7.50016 6.95197 7.50016 8.33268C7.50016 9.71339 8.61945 10.8327 10.0002 10.8327Z"/><path d="M10.0002 18.3327C13.3335 14.9993 16.6668 12.0146 16.6668 8.33268C16.6668 4.65078 13.6821 1.66602 10.0002 1.66602C6.31826 1.66602 3.3335 4.65078 3.3335 8.33268C3.3335 12.0146 6.66683 14.9993 10.0002 18.3327Z"/></g>'
  }
})